export default "__VITE_ASSET__DlOe4EKN__"